import { render, staticRenderFns } from "./SystemSettingsplugin.vue?vue&type=template&id=47f985bc&scoped=true"
import script from "./SystemSettingsplugin.vue?vue&type=script&lang=js"
export * from "./SystemSettingsplugin.vue?vue&type=script&lang=js"
import style0 from "./SystemSettingsplugin.vue?vue&type=style&index=0&id=47f985bc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47f985bc",
  null
  
)

export default component.exports